import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  InputAdornment,
  Card,
  Stack,
  FormControlLabel,
  Switch,
  Typography,
  Box,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  RESET_GROUP_STATE,
  START_CREATE_GROUP,
  START_UPDATE_GROUP,
  START_GET_SINGLE_GROUP,
  START_UPDATE_ORDERDATE_GROUP,
} from "../../Actions/GroupAction";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import { useFormik } from "formik";
import { useXssGuard } from "Hooks/useXssGuard";
import { connect } from "react-redux";
import * as yup from "yup";
import { useNotification } from "../../Hooks/NotificationManager";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import { useColor } from "react-color-palette";
import { ChromePicker } from "react-color";
import { PreferredOrderDay } from "../../utils/data";
import "react-color-palette/lib/css/styles.css";
import { setLocalStorage } from "../../utils/generalUtils";
import "../../Sass/Common.scss";
import { ReactComponent as Info } from "../../Assets/Icons/info.svg";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import PatientAutoComplete from "../../Components/Groups/PatientAutoComplete";
import { START_GET_PATIENT_LIST } from "../../Actions/PatientAction";
import { START_GET_HOME_LIST } from "../../Actions/HomeAction";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ConfirmationOrderDialog from "./ConfirmationOrderDialog";
import moment from "moment";
const useStyle = makeStyles((theme) => ({
  rsMain: {
    // "& .MuiDialog-paper": {
    //   maxWidth: "558px !important",
    // },
  },
  dialogContent: {
    padding: "55px 0px !important",
  },
  rsOrderDate: {
    display: "flex",
  },
  rsDateField: {
    "&>div": {
      "&>div": {
        marginLeft: "-20px !important",
      },
    },
    "&>p": {
      marginLeft: "0px",
    },
  },
}));

const NextOrderDateDailog = (props) => {
  const {
    open,
    setOpen,
    editData,
    setEditData,
    groupRecordActionType,
    createGroupData,
    resetGroupState,
    updateGroupAction,
    updateGroupData,
    getSingleGroupAction,
    singleGroup,
    setGroupRecordActionType,
    getList,
    getPatientListAction,
    getHomeListAction,
    createGroupAction,
    updateOrderDateAction,
    updateOrderDate,
  } = props;
  const classes = useStyle();
  const formState = {
    g_order_date: "",
  };
  const notification = useNotification();
  const [groupData, setGroupData] = useState(formState);
  const [isOpenOrderDate, setIsOpenOrderDate] = useState(false);
  const [openConfirmOrderDate, setOpenConfirmOrderDate] = useState(false);
  const [nextOrderDialog, setNextOrderDialog] = useState(false);
  let _groupSchema = {};
  _groupSchema = {
    g_order_date: yup
      .string()
      .nullable()
      .required("The next order date field is required."),
  };

  const groupSchema = yup.object().shape(_groupSchema);

  /* Handle Group Create And Update */
  const handleAddGroupOrEditGroup = (formValues) => {
    const selectedPatients = formValues?.patient_ids?.map((item) => {
      return item.id;
    });
    let payload = {};
    if (editData?.g_cycle_day) {
      payload.g_cycle_day = editData?.g_cycle_day || "28";
    } else {
      payload.g_cycle_day = editData?.g_cycle_day || "28";
    }
    if (formValues?.g_order_date) {
      payload.g_order_date = moment(new Date(formValues?.g_order_date)).format(
        "YYYY-MM-DD"
      );
    }
    setOpenConfirmOrderDate(true);
    if (openConfirmOrderDate) {
      updateOrderDateAction(editData?.g_id, payload);
      setNextOrderDialog(true);
    }
  };

  const { guardedSubmit: xssGuardedNextOrderDate } = useXssGuard(handleAddGroupOrEditGroup);


  /* Formik */
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    handleBlur,
    resetForm,
    setErrors,
    setFieldValue,

} = useFormik({
    initialValues: { ...groupData },
    validationSchema: groupSchema,
    enableReinitialize: true,
    onSubmit: xssGuardedNextOrderDate,
  });
  /* Handle Close */
  const handleClose = () => {
    setOpen(false);
    setGroupData({
      ...formState,
    });
    setEditData({});
    resetForm();
    resetGroupState("createGroupData");
    resetGroupState("updateGroupData");
    resetGroupState("singleGroup");
    setLocalStorage("group_name", "");
    setFieldValue("g_order_date", "");
    setOpenConfirmOrderDate(false);
  };

  /* Edit Single Data API Calling UseEffect */
  useEffect(() => {
    if (open) {
      if (groupRecordActionType === "editGroupDetail") {
        getSingleGroupAction(editData?.g_id);
        setGroupData({
          g_order_date: editData?.g_order_date || "",
        });
      }
    } else {
      setGroupData(formState);
    }
  }, [open]);

  /* Popup Open based on show data in edit form useEffect */
  useEffect(() => {
    if (
      groupRecordActionType === "editGroupDetail" &&
      Object.keys(singleGroup?.data)?.length > 0
    ) {
      let newPatientList = [];
      singleGroup?.data?.patient_info?.map((patientList) => {
        newPatientList[patientList.pg_pi_id] = {
          ...patientList,
          id: patientList?.pg_pi_id,
          name: patientList?.name,
        };
      });
      setGroupData({
        // g_name: singleGroup?.data?.g_name || "",
        // patient_ids: newPatientList,
        // g_color_code: singleGroup?.data?.g_color_code || "",
        // g_is_preferred_order_day: singleGroup?.data?.g_is_preferred_order_day,
        // g_preferred_order_day:
        //   singleGroup?.data?.g_is_preferred_order_day === false
        //     ? "Friday"
        //     : singleGroup?.data?.g_preferred_order_day,
        g_order_date: singleGroup?.data?.g_order_date || "",
      });
    }
  }, [singleGroup?.data]);

  /* Create And Update loading UseEffect */
  useEffect(() => {
    if (
      (!createGroupData?.loading &&
        Object.keys(createGroupData?.data || {})?.length > 0) ||
      (!updateGroupData?.loading &&
        Object.keys(updateGroupData?.data || {})?.length > 0 &&
        nextOrderDialog)
    ) {
      if (groupRecordActionType === "editGroupDetail") {
        notification.success("Group Updated successfully");

        resetGroupState("updateGroupData", "");
      } else if (groupRecordActionType === "addPatientInGroup") {
        notification.success("Patient  Added successfully");
        setGroupRecordActionType("");
      }
      resetGroupState("createGroupData", "");
      handleClose();
      setNextOrderDialog(false);
      // getList();
      let payload = {};
      // getHomeListAction(payload);
    }
  }, [createGroupData, updateGroupData]);

  /* Server Side Validation Error useEffect */
  useEffect(() => {
    const errors =
      groupRecordActionType === "createNewGroup"
        ? createGroupData?.error?.errors
        : updateGroupData?.error?.errors;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};
      let errorsBasedPatients = [];
      Object.entries(errors)?.map(([error, value]) => {
        if (error.indexOf("new_patient_ids") > -1) {
          //Map of selected patient to get name
        } else {
          obj[error] = value[0];
          return error;
        }
      });

      Object.entries(errors)?.map(([error, value]) => {
        if (error.indexOf("patient_ids") > -1) {
          //Map of selected patient to get name
        } else {
          obj[error] = value[0];
          return error;
        }
      });

      if (errorsBasedPatients.length > 0) {
        let message = errorsBasedPatients.length === 1 ? "is" : "are";
        obj.patient_ids = `${errorsBasedPatients.join(
          ", "
        )} ${message} already  in one group please choose another patient`;
      }
      setErrors(obj);
    }
  }, [createGroupData?.error, updateGroupData.error]);

  useEffect(() => {
    let payLoad = {
      offset: 0,
    };
    if (updateOrderDate?.data?.success && nextOrderDialog) {
      getPatientListAction(payLoad);
      let payLoadGroup = {
        offset: 0,
        limit: 20,
      };
      let payload = {};
      getHomeListAction(payload);
      getList(payLoadGroup);
      setNextOrderDialog(false);
    }
  }, [updateOrderDate?.data?.success]);
  /* Detach Server Side Validation Function */
  const returnServerError = (errorKey) => {
    let errorObj = {
      keyPresent: false,
      message: "",
    };

    let errorBag =
      groupRecordActionType === "createNewGroup"
        ? updateOrderDate?.error?.errors
        : updateOrderDate?.error?.errors;
    if (errorBag?.hasOwnProperty(errorKey)) {
      errorObj = {
        keyPresent: true,
        message: errorBag?.[errorKey]?.[0],
      };
    }
    return errorObj;
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"xs"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={classes.rsMain}
      >
        <PrimaryDialogTitle
          handleClose={handleClose}
          title={"Edit New Order Date"}
        />
        <form
          name="registration"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <DialogContent className={classes.dialogContent}>
            <Grid container columnSpacing={2.5} rowSpacing={3}>
              {groupRecordActionType !== "addPatientInGroup" && (
                <>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className={classes.rsOrderDate}
                  >
                    {/* <Typography color="secondary" regular variant="h4">
                      Next Order Date
                    </Typography> */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        id="g_order_date"
                        name="g_order_date"
                        label="Next Order Date *"
                        className={classes.rsDateField}
                        views={["year", "month", "day"]}
                        inputFormat="DD-MM-YYYY"
                        minDate={new Date()}
                        open={isOpenOrderDate}
                        onClose={() => setIsOpenOrderDate(false)}
                        value={values?.g_order_date}
                        onChange={(newDate) => {
                          setFieldValue("g_order_date", newDate);
                        }}
                        renderInput={(params) => (
                          <TextField
                            id="g_order_date"
                            onClick={() => setIsOpenOrderDate(true)}
                            fullWidth
                            size="small"
                            name="g_order_date"
                            {...params}
                            error={
                              touched?.g_order_date && errors?.g_order_date
                            }
                            helperText={
                              touched?.g_order_date && errors?.g_order_date
                            }
                            onBlur={handleBlur}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </>
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              type="submit"
              disabled={
                createGroupData?.loading ||
                updateGroupData?.loading ||
                singleGroup?.loading
              }
              startIcon={
                (createGroupData?.loading || updateGroupData?.loading) && (
                  <CircularProgress color="white" size="20px" />
                )
              }
            >
              Submit
            </Button>
            <Button variant="outlined" onClick={() => handleClose()}>
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <ConfirmationOrderDialog
        open={openConfirmOrderDate}
        setOpen={setOpenConfirmOrderDate}
        add={
          groupRecordActionType === "editGroupDetail"
            ? "edit"
            : groupRecordActionType === "createNewGroup"
            ? "add"
            : "null"
        }
        handleSubmit={handleSubmit}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  createGroupData: state.group.createGroupData,
  updateGroupData: state.group.updateGroupData,
  singleGroup: state.group.singleGroup,
  updateOrderDate: state.group.updateOrderDate,
});

const mapDispatchToProps = (dispatch) => ({
  createGroupAction: (payload) =>
    dispatch({ type: START_CREATE_GROUP, payload }),
  updateGroupAction: (id, payload) =>
    dispatch({ type: START_UPDATE_GROUP, id, payload }),

  resetGroupState: (key, payload) =>
    dispatch({ type: RESET_GROUP_STATE, key, payload }),
  getSingleGroupAction: (id) => dispatch({ type: START_GET_SINGLE_GROUP, id }),
  getPatientListAction: (payload) =>
    dispatch({ type: START_GET_PATIENT_LIST, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
  updateOrderDateAction: (id, payload) =>
    dispatch({ type: START_UPDATE_ORDERDATE_GROUP, id, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NextOrderDateDailog);
